module.exports = __webpack_public_path__ + "static/ad-banner-image-082357a383973c091fedfe1ff0b9a44c.png";